export default function () {
    return {
        title: 'SQL Table',
        query: 'SELECT sumTime FROM $EXPLY',
    }
}
